/** Maps advanced programme IDs to learner training-interest keys (mirrors backend programme_access). */
export const PROGRAMME_TO_TRAINING_INTEREST = {
  "programme-manual-driving": "manual_driving",
  "programme-tourism-visitor": "overseas_driver",
  "programme-older-driver": "older_driver_refresher",
  "programme-school-university": "school_university",
};

export function trainingInterestForProgramme(programmeId) {
  return PROGRAMME_TO_TRAINING_INTEREST[programmeId] || null;
}
